// extracted by mini-css-extract-plugin
export default {"body":"como-funciona_body__r+aBB"};